/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiARewindBackIcon16Light } from './MediaUiARewindBackIcon16Light';
import { MediaUiARewindBackIcon16Regular } from './MediaUiARewindBackIcon16Regular';
import { MediaUiARewindBackIcon16Solid } from './MediaUiARewindBackIcon16Solid';
import { MediaUiARewindBackIcon20Light } from './MediaUiARewindBackIcon20Light';
import { MediaUiARewindBackIcon20Regular } from './MediaUiARewindBackIcon20Regular';
import { MediaUiARewindBackIcon20Solid } from './MediaUiARewindBackIcon20Solid';
import { MediaUiARewindBackIcon24Regular } from './MediaUiARewindBackIcon24Regular';
import { MediaUiARewindBackIcon24Solid } from './MediaUiARewindBackIcon24Solid';
import { MediaUiARewindBackIcon32Regular } from './MediaUiARewindBackIcon32Regular';
import { MediaUiARewindBackIcon64Regular } from './MediaUiARewindBackIcon64Regular';
var sizes = {
    16: {
        light: MediaUiARewindBackIcon16Light,
        regular: MediaUiARewindBackIcon16Regular,
        solid: MediaUiARewindBackIcon16Solid,
    },
    20: {
        light: MediaUiARewindBackIcon20Light,
        regular: MediaUiARewindBackIcon20Regular,
        solid: MediaUiARewindBackIcon20Solid,
    },
    24: {
        regular: MediaUiARewindBackIcon24Regular,
        solid: MediaUiARewindBackIcon24Solid,
    },
    32: {
        regular: MediaUiARewindBackIcon32Regular,
    },
    64: {
        regular: MediaUiARewindBackIcon64Regular,
    },
};
export var MediaUiARewindBackIcon = forwardRef('MediaUiARewindBackIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
